// trackingApiUrlMap is not exported from @qubictron/url — Parcel carriers API disabled for now.
// import { trackingApiUrlMap } from "@qubictron/url";
import axios from "axios";
import { ParcelCompaniesResponseTypesDTO } from "./response.types";
import { injectDataInterceptor } from "shared/api/utils/api.utils";

// const CARRIERS_API_URL = trackingApiUrlMap.prod().appendPathname("info/parcel_companies").build();
const CARRIERS_API_URL = "";

const parcelCarriersRequestInstance = axios.create();
parcelCarriersRequestInstance.defaults.baseURL = CARRIERS_API_URL;
injectDataInterceptor(parcelCarriersRequestInstance);

class ParcelCarriersApi {
  public getParcelCarriers(): Promise<ParcelCompaniesResponseTypesDTO> {
    return parcelCarriersRequestInstance.get("");
  }
}

export const parcelCarriersService = new ParcelCarriersApi();
